import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CircleSpinner } from 'react-spinners-kit';
import { getDonationRedirectUrl } from '../utils/donationRedirect';

export const StripeCancelRedirect: React.FC = () => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const donationId = searchParams.get('donationId') || '';
  const platform = (searchParams.get('platform') || '').toLowerCase();

  const redirectUrl = getDonationRedirectUrl({
    donationId,
    platform,
    status: 'cancel',
  });

  useEffect(() => {
    window.location.href = redirectUrl;
  }, [redirectUrl]);

  const containerStyle: React.CSSProperties = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f3f4f6', // neutral gray
    padding: '24px',
  };

  const cardStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: '480px',
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    padding: '32px 24px',
    boxShadow: '0 10px 40px rgba(15, 23, 42, 0.12)',
    textAlign: 'center',
  };

  const titleStyle: React.CSSProperties = {
    fontSize: '24px',
    fontWeight: 700,
    color: '#374151',
    marginBottom: '8px',
  };

  const subtitleStyle: React.CSSProperties = {
    fontSize: '14px',
    color: '#4b5563',
    marginBottom: '24px',
  };

  const buttonStyle: React.CSSProperties = {
    marginTop: '24px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 18px',
    borderRadius: '9999px',
    backgroundColor: '#4b5563',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: 600,
    textDecoration: 'none',
  };

  const spinnerWrapperStyle: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '12px',
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={spinnerWrapperStyle}>
          <CircleSpinner size={28} color="#6b7280" />
        </div>
        <h1 style={titleStyle}>Payment Cancelled</h1>
        <p style={subtitleStyle}>Returning to app...</p>
        <p style={{ fontSize: '12px', color: '#6b7280' }}>
          You can safely close this tab, or tap the button below to return to the Risen Hope app.
        </p>
        <a href={redirectUrl} style={buttonStyle}>
          Click here if you aren&apos;t redirected
        </a>
      </div>
    </div>
  );
};
